import { useCallback, useSyncExternalStore } from "react";
import { getDeviceAccount, setDeviceAccount, type DeviceAccount } from "#device-account-store";
import { deviceAccountStorage } from "#device-settings-store";

const DEVICE_ACCOUNT_KEY = "device-account:current";

let deviceAccountSnapshot: DeviceAccount | null = null;
let deviceAccountSnapshotKey = "";

function getDeviceAccountSnapshot(): DeviceAccount | null {
  const account = getDeviceAccount();
  // `tursoDbSyncUrl` is optional (absent in dev, where the URL is env-sourced), so default it to
  // "" rather than letting it interpolate to the literal "undefined".
  const snapshotKey =
    account == null ? "" : `${account.tursoDbAuthToken}\0${account.tursoDbSyncUrl ?? ""}`;
  if (snapshotKey === deviceAccountSnapshotKey) {
    return deviceAccountSnapshot;
  }
  deviceAccountSnapshotKey = snapshotKey;
  deviceAccountSnapshot = account;
  return account;
}

export function useDeviceAccount(): [DeviceAccount | null, (value: DeviceAccount | null) => void] {
  const subscribe = useCallback((onChange: () => void) => {
    const unwatch = deviceAccountStorage.watch((_event, changedKey) => {
      if (changedKey === DEVICE_ACCOUNT_KEY) {
        onChange();
      }
    });
    return () => {
      unwatch();
    };
  }, []);
  const getSnapshot = useCallback(() => getDeviceAccountSnapshot(), []);
  const value = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const setValue = useCallback((next: DeviceAccount | null) => setDeviceAccount(next), []);
  return [value, setValue];
}
